export const VIDEO_PROMOTION_INDEX = 3;

const useLiveJobPreviewIndex = (originalIndex: number) => {
  if (originalIndex <= VIDEO_PROMOTION_INDEX) {
    return originalIndex;
  }
  return originalIndex - 1;
};

export default useLiveJobPreviewIndex;
